import { IApplicationStatus } from 'types';

import { createAction } from './utils';

export const SET_APPLICATION_STATUS = 'SET_APPLICATION_STATUS';
export const setApplicationStatusAction = (status: IApplicationStatus) => createAction(SET_APPLICATION_STATUS, status);
